import React, { useEffect, useState } from 'react';
import Loader from '@components/common/Loader';
import { APP_CONFIG, COUNTRY_CODE } from '@constants';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import ReceiptScreen from '@components/ReceiptScreen';
import PaymentScreen from '@components/PaymentScreens';
import Modal from '@components/common/Modal';
import cn from 'classnames';
import style from './viewreceipt.module.scss';
import {
  paymentInitialization,
  paymentCash,
  paymentAuth,
  paymentAuthError,
  paymentAuthComplete,
  receiptEmail,
  receiptSms,
  paymentSignature,
  setAuthResponse,
  receiptPrint,
  giftCardBalance,
  giftCardPaymentInit,
  giftCardPayments,
} from '@reducers/payment';
import { updateChecksAfterResponse } from '@reducers/storeChecks';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  setNotification,
  setPrintNotification,
  closePrintNotification,
} from '@reducers/notification';
import ReceiptScreenPopUp from '@components/checksCommon/receiptscreenPopUp';
import {
  removeSeat,
  removePaymentCheck,
  updateSeatInfo,
  setPaymentCheck,
} from '@reducers/orders';
import { isEmpty } from 'lodash';
import EventEmitter from '@utility/eventSubscribers';
import { getObjectValue, urlSearchParams } from '@utility/utills';
import TipsConfirmPopUp from './tipsConfirmationPopUp';
import { submitSurvey, getSurvey } from '@reducers/survey';
import { flowType } from '@utility/userInfo';

const ProcessAuthFlow = props => {
  const [tableData, setTableData] = useState(props.paymentCheck);
  const [signUrl, setSignUrl] = useState('');
  const [isTipsConfirm, setIsTipsConfirm] = useState(false);
  const [confModelOpen, setConfModelOpen] = useState(false);
  const [splitAmountValue, setSplitAmountValue] = useState(0);
  const [paymentAuthResponse, setPaymentAuthResponse] = useState(null);
  const [giftBalance, setGiftBalance] = useState(0);
  const storeTips = props.auth.tipInfo.tips.map(item => {
    return props.auth.tipInfo.ruleType === 1
      ? {
          key: item.value * 100,
          displayKey: `${item.value * 100} %`,
        }
      : {
          key: item.value,
          displayKey: `${item.value} %`,
        };
  });
  const tipsList = [
    ...storeTips,
    {
      key: `Other ${LABEL().CURRENCY_SYMBOL}`,
      displayKey: `Other ${LABEL().CURRENCY_SYMBOL}`,
    },
    { key: 'Other %', displayKey: 'Other %' },
  ];
  const [active, setActive] = useState(
    props.auth.tipInfo.tips.find(item => item.isDefault === true).value
  );
  const hideSignature =
    props.auth.serverAppFeatures.supportsNoSignatureOnPayment;
  const [paymentType, setPaymentType] = useState(1);
  const currenySymbol = LABEL().CURRENCY_SYMBOL;
  const [tipAmount, setTipAmount] = useState(tableData.tipAmount.toFixed(2));
  const [paymentAmount, setPaymentAmount] = useState(
    tableData.unpaidAmount.toFixed(2)
  );
  const [isReceipt, setIsReceipt] = useState({});
  const [keyboardValue, setKeyboardValue] = useState('');
  const supportsSurvey = getObjectValue(
    () => props.auth.serverAppFeatures.supportsSurvey,
    false
  );
  const selectedAnswers =
    JSON.parse(window.sessionStorage.getItem('selectedQuestions')) || [];
  const defaultCountryCode = getObjectValue(
    () => COUNTRY_CODE[props.auth.country].dialCode,
    1
  );
  const phoneNumberMaxLength = getObjectValue(
    () => COUNTRY_CODE[props.auth.country].maxLength,
    1
  );
  const supportsWarnOnUnusualTip = getObjectValue(
    () => props.auth.tipInfo.warnIfTipUnusual,
    false
  );
  const [countryCode, setCountryCode] = useState(defaultCountryCode);

  const handleBackButton = () => {
    let temp = { isShow: false, url: () => {} };
    const type = () => {
      switch (Number(urlSearchParams('ticketSplitTypeId'))) {
        case 1:
          return tableData.paymentStages.length === 0
            ? '&type=cash'
            : '&type=stage';
        default:
          return '';
      }
    };
    if ([2, 9, 10, 12].includes(paymentType)) {
      switch (urlSearchParams('type')) {
        case 'stage': {
          temp = {
            isShow: true,
            url: () =>
              props.history.replace(
                `${APP_CONFIG.BASE_URL}/stagepayment/${tableData.id}`
              ),
          };
          break;
        }
        case 'cash': {
          temp = {
            isShow: true,
            url: () => {
              setPaymentType(1);
              props.history.replace(
                `${APP_CONFIG.BASE_URL}/receipt/${tableData.id}?ticketSplitTypeId=1&splitValue=1&screenType=1`
              );
            },
          };
          break;
        }
        case 'payAnAmount':
        case 'split': {
          temp = {
            isShow: true,
            url: () => {
              setPaymentType(1);
              props.history.replace(
                `${APP_CONFIG.BASE_URL}/receipt/${tableData.id}?ticketSplitTypeId=1&splitValue=1&screenType=1`
              );
            },
          };
          break;
        }
        case 'gift': {
          temp = {
            isShow: true,
            url: () => {
              setPaymentType(2);
              props.history.replace(
                `${APP_CONFIG.BASE_URL}/receipt/${
                  tableData.id
                }?ticketSplitTypeId=${urlSearchParams(
                  'ticketSplitTypeId'
                )}&splitValue=${urlSearchParams(
                  'splitValue'
                )}&screenType=2${type()}`
              );
            },
          };
          break;
        }
        default:
          break;
      }
    }
    return temp;
  };

  useEffect(() => {
    setPaymentType(Number(urlSearchParams('screenType')));
    setTipAmount(0);
    setTableData(props.paymentCheck);
  }, [props.paymentCheck]);

  const SeatIds = () => {
    return tableData.seats.reduce((a, v) => {
      if (v.open) a.push(v.id);
      return a;
    }, []);
  };

  const handlePrint = () => {
    props
      .receiptPrint({
        deviceId: props.deviceInfo.deviceId,
        employeeId: Number(props.userInfo.id),
        storeId: props.deviceInfo.storeId,
        employeeCard: props.userInfo.employeeCard,
        ticketId: props.authResponse.ticket.id,
      })
      .then(res => {
        if (window.ReactNativeWebView) {
          EventEmitter.print(res);
        }
        props.setPrintNotification(res);
      })
      .catch(err => {
        props.setNotification({
          type: 'danger',
          message: err.message,
        });
      });
  };

  const handleButtonClick = (item, value) => {
    const subTotalAmount = getObjectValue(() => tableData.subTotalAmount, 0);
    setActive(item);
    if (item === storeTips[0].key) {
      const tipamt = ((subTotalAmount * storeTips[0].key) / 100).toFixed(2);
      const payAmt = (Number(tipamt) + Number(subTotalAmount)).toFixed(2);
      setTipAmount(tipamt);
      setPaymentAmount(payAmt);
    } else if (item === storeTips[1].key) {
      const tipamt = ((subTotalAmount * storeTips[1].key) / 100).toFixed(2);
      const payAmt = (Number(tipamt) + Number(subTotalAmount)).toFixed(2);
      setTipAmount(tipamt);
      setPaymentAmount(payAmt);
    } else if (item === storeTips[2].key) {
      const tipamt = ((subTotalAmount * storeTips[2].key) / 100).toFixed(2);
      const payAmt = (Number(tipamt) + Number(subTotalAmount)).toFixed(2);
      setTipAmount(tipamt);
      setPaymentAmount(payAmt);
    } else if (
      item === `Other ${LABEL().CURRENCY_SYMBOL}` &&
      value &&
      value.length > 0
    ) {
      const tipamt = Number(value).toFixed(2);
      const payAmt = (Number(value) + Number(subTotalAmount)).toFixed(2);
      setTipAmount(tipamt);
      setPaymentAmount(payAmt);
    } else if (item === 'Other %' && value && value.length > 0) {
      const tipamt = ((subTotalAmount * Number(value)) / 100).toFixed(2);
      const payAmt = (Number(tipamt) + Number(subTotalAmount)).toFixed(2);
      setTipAmount(tipamt);
      setPaymentAmount(payAmt);
    } else {
      setTipAmount(0.0);
      setPaymentAmount(parseFloat(subTotalAmount));
    }
  };

  const renderModifier = modifiersObj =>
    (modifiersObj || []).map(modifier => (
      <div
        key={modifier.modifierId}
        className={modifier.price ? 'col-12 text-left p-0 fs-18' : 'd-none'}
      >
        {`${modifier.quantity > 1 ? `- ${modifier.quantity} x ` : '- '} ${
          modifier.modifierName
        } ${
          modifier.price ? `(${currenySymbol}${modifier.price.toFixed(2)})` : ''
        }`}
        {(modifier.note || modifier.comment) && (
          <div className="pl-2">{modifier.note || modifier.comment}</div>
        )}
        {modifier.modifiers && modifier.modifiers.length > 0 && (
          <div className="pl-2">{renderModifier(modifier.modifiers)}</div>
        )}
      </div>
    ));

  const handleRoute = () => {
    setTipAmount(0);
    setKeyboardValue('');
    setActive('');
    const authResponse = getObjectValue(
      () => JSON.parse(window.sessionStorage.getItem('authResponse')),
      0
    );
    const discount = getObjectValue(
      () => authResponse.checkHeader.discountAmount,
      0
    );
    const serviceCharge = getObjectValue(
      () => authResponse.checkHeader.serviceChargeAmount,
      0
    );
    const subtotalAmount = getObjectValue(
      () => authResponse.checkHeader.subTotalAmount,
      0
    );
    const taxAmount = getObjectValue(
      () => authResponse.checkHeader.taxAmount,
      0
    );
    if (urlSearchParams('ticketSplitTypeId') === '1') {
      if (
        urlSearchParams('type') === 'stage' &&
        authResponse.checkHeader.paymentStages.filter(d => d.status === 0)
          .length > 0
      ) {
        props.updateSeatInfo(authResponse.checkHeader).then(() => {
          props.history.replace(
            `${APP_CONFIG.BASE_URL}/stagepayment/${tableData.id}`
          );
        });
      } else if (Number(authResponse.checkHeader.unpaidAmount > 0)) {
        props
          .setPaymentCheck({
            ...authResponse.checkHeader,
          })
          .then(() => {
            props.history.replace({
              pathname: `${APP_CONFIG.BASE_URL}/receipt/${authResponse.checkHeader.id}?ticketSplitTypeId=1&splitValue=1&screenType=2`,
            });
          });
      } else {
        props.removeSeat();
        props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`);
      }
    } else if (urlSearchParams('ticketSplitTypeId') === '4') {
      props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`);
    } else if (urlSearchParams('ticketSplitTypeId') === '2') {
      props.setPaymentCheck({
        ...authResponse.checkHeader,
        totalAmount: Number(
          subtotalAmount + taxAmount + serviceCharge - discount
        ),
        paidAmount: authResponse.checkHeader.paidAmount,
      });
      props.updateSeatInfo(authResponse.checkHeader).then(() => {
        if (
          Number(authResponse.checkHeader.paidAmount) <
          Number(authResponse.checkHeader.totalAmount)
        ) {
          props.history.replace({
            pathname: `${APP_CONFIG.BASE_URL}/receipt/${authResponse.checkHeader.id}?ticketSplitTypeId=2&splitValue=1&screenType=1`,
          });
        } else {
          props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`);
        }
      });
    } else if (urlSearchParams('ticketSplitTypeId') === '3') {
      props.setPaymentCheck({
        ...authResponse.checkHeader,
        totalAmount: Number(
          subtotalAmount + taxAmount + serviceCharge - discount
        ),
        paidAmount: authResponse.checkHeader.paidAmount,
      });
      props.updateSeatInfo(authResponse.checkHeader).then(() => {
        if (
          Number(authResponse.checkHeader.paidAmount) <
          Number(authResponse.checkHeader.totalAmount)
        ) {
          props.history.replace({
            pathname: `${APP_CONFIG.BASE_URL}/receipt/${authResponse.checkHeader.id}?ticketSplitTypeId=3&splitValue=${splitAmountValue.count}&screenType=1`,
          });
        } else {
          props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`);
        }
      });
    } else {
      props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`);
    }
  };

  const submitSurveyResponse = surveyDataItem => {
    const authResponse = getObjectValue(
      () => JSON.parse(window.sessionStorage.getItem('authResponse')),
      0
    );
    let surveyResponse = [];
    if (surveyDataItem.questions.length > 0) {
      surveyResponse = surveyDataItem.questions.map(data => {
        return (
          selectedAnswers &&
          selectedAnswers.length > 0 &&
          !selectedAnswers.some(
            selectedQuest => selectedQuest.questionId === data.id
          ) && { questionId: data.id, responseId: null }
        );
      });
    }
    if (selectedAnswers.length === 0) {
      surveyResponse = surveyDataItem.questions.map(data => {
        return { questionId: data.id, responseId: null };
      });
    }
    const sendJson = {
      storeId: props.deviceInfo.storeId,
      ticketId: getObjectValue(() => authResponse.ticket.id, null),
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      employeeCard: props.userInfo.employeeCard,
      checkHeaderId: tableData.id,
      responses: [...selectedAnswers, ...surveyResponse.filter(e => e)],
    };
    props
      .submitSurvey(JSON.stringify(sendJson))
      .then(() => setPaymentType(11))
      .catch(err => {
        props.setNotification({
          type: 'danger',
          message: err.message,
        });
        setPaymentType(5);
      });
  };

  const getItems = () => {
    const itemArray = [];
    props.seat.items.forEach(item => {
      itemArray.push({
        quantity: item.quantity,
        menuItemId: item.menuItemId,
        modifiers: item.modifiers,
      });
    });
    return itemArray;
  };

  const getSurveyResponse = () => {
    const orders = getItems();
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      employeeCard: props.userInfo.employeeCard,
      items: orders,
    };
    props
      .getSurvey(dataToSend)
      .then(val => {
        submitSurveyResponse(val);
      })
      .catch(err => {
        props.setNotification({
          type: 'danger',
          message: err.message,
        });
        setPaymentType(5);
      });
  };

  const handleCashPayment = () => {
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      employeeCard: props.userInfo.employeeCard,
      checkHeaderId: tableData.id,
      ticketSplitTypeId: Number(urlSearchParams('ticketSplitTypeId')),
      splitValue: Number(urlSearchParams('splitValue')),
      paymentStageId: getObjectValue(
        () => props.paymentCheck.paymentStageId,
        null
      ),
      subTotalAmount: tableData.subTotalAmount,
      taxAmount: tableData.taxAmount || 0.0,
      seatIds: SeatIds(),
      serviceChargeAmount: tableData.serviceChargeAmount || 0.0,
      discountAmount: tableData.discountAmount || 0.0,
    };
    props
      .paymentCash(dataToSend)
      .then(res => {
        props.setPaymentCheck({ ...props.paymentCheck, ...res.ticket });
        props.setAuthResponse(res).then(() => {
          setPaymentType(5);
        });
      })
      .catch(err => {
        props.setNotification({
          type: 'danger',
          message: err.message,
        });
      });
  };

  const handleCreditCard = () => {
    const subTotalAmount = Number(tableData.subTotalAmount).toFixed(2);
    const taxAmount = Number(tableData.taxAmount).toFixed(2);
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: tableData.id,
      employeeCard: props.userInfo.employeeCard,
      ticketSplitTypeId: Number(urlSearchParams('ticketSplitTypeId')),
      splitValue: Number(urlSearchParams('splitValue')),
      paymentStageId: getObjectValue(
        () => props.paymentCheck.paymentStageId,
        null
      ),
      subTotalAmount,
      taxAmount,
      totalAmount: Number(tableData.totalAmount).toFixed(2),
      unpaidAmount: Number(tableData.unpaidAmount).toFixed(2),
      seatIds: SeatIds(),
      serviceChargeAmount: Number(tableData.serviceChargeAmount).toFixed(2),
      discountAmount: Number(tableData.discountAmount).toFixed(2),
    };
    props
      .paymentInitialization(dataToSend)
      .then(val => {
        props.setAuthResponse(val).then(() => {
          const data = {
            type: 'processPayment',
            data: {
              merchantInvoiceId: val.ticket.id.toString(),
              employeeId: val.checkHeader.employeeId.toString(),
              employeeCard: props.userInfo.employeeCard,
              latitude: '0',
              longitude: '0',
              notes: '',
              referenceId: val.ticket.id.toString() || val.ticket.referenceId,
              amount: Math.floor(val.ticket.totalAmount * 100).toString(),
            },
          };
          EventEmitter.sendMessage(
            data,
            res => {
              console.log(res);
            },
            err => {
              console.log(err);
            }
          );
          setPaymentType(3);
        });
      })
      .catch(err => {
        props.setNotification({
          type: 'danger',
          message: err.message,
        });
      });
  };

  const handleCreditCardAuth = data => {
    setPaymentAuthResponse(data);
    const aAmt = (data.authorizedAmount / 100).toFixed(2);
    const dataToSend = {
      deviceId: props.deviceInfo.deviceId,
      employeeCard: props.userInfo.employeeCard,
      employeeId: props.userInfo.id,
      checkHeaderId: tableData.id,
      ticketId: props.authResponse.ticket.id,
      storeId: props.deviceInfo.storeId,
      subtotalAmount: getObjectValue(
        () =>
          props.authResponse.ticket.subtotalAmount ||
          props.authResponse.ticket.subTotalAmount,
        0
      ),
      taxAmount: props.authResponse.ticket.taxAmount,
      authAmount: aAmt,
      cardHolderName: data.cardholderName,
      redactedCardNumber: data.redactedCardNumber,
      cardExpirationDate: data.cardExpirationDate,
      cardType: data.cardType,
      uniqueCardIdentifier: data.uniqueCardIdentifier,
      transactionId: data.transactionId,
      clientTransactionId: data.clientTransactionId,
      authorizationCode: data.authCode,
      paymentStageId: getObjectValue(
        () => props.paymentCheck.paymentStageId,
        null
      ),
      message: '',
      cardMethod: 'insert',
      isPreAuth: false,
      partialAuth: false,
      serviceChargeAmount: getObjectValue(
        () => props.authResponse.ticket.serviceChargeAmount,
        0
      ),
      discountAmount: getObjectValue(
        () => props.authResponse.ticket.discountAmount,
        0
      ),
    };
    if (data.transactionApproved) {
      props
        .paymentAuth(dataToSend)
        .then(() => {
          setPaymentType(4);
        })
        .catch(() => {
          props.paymentAuthError(dataToSend);
        });
    } else {
      setPaymentType(8);
      props.paymentAuthError(dataToSend);
    }
  };

  const completePaymentListener = response => {
    const aAmt = (response.authorizedAmount / 100).toFixed(2);
    const authResponse = getObjectValue(
      () => JSON.parse(window.sessionStorage.getItem('authResponse')),
      0
    );
    const dataToSend = {
      message: '',
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: tableData.id,
      ticketId: authResponse.ticket.id,
      subtotalAmount: getObjectValue(
        () =>
          authResponse.ticket.subtotalAmount ||
          authResponse.ticket.subTotalAmount,
        0
      ),
      taxAmount: authResponse.ticket.taxAmount,
      authAmount: aAmt,
      tipAmount: Number(window.sessionStorage.getItem('tipAmt')).toFixed(2),
      transactionId: response.transactionId,
      clientTransactionId: response.clientTransactionId,
      authorizationCode: response.authorizationCode,
      paymentStageId: getObjectValue(
        () => props.paymentCheck.paymentStageId,
        null
      ),
      employeeCard: props.userInfo.employeeCard,
      isPreAuth: false,
      partialAuth: false,
      serviceChargeAmount: getObjectValue(
        () => authResponse.ticket.serviceChargeAmount,
        0
      ),
      discountAmount: getObjectValue(
        () => authResponse.ticket.discountAmount,
        0
      ),
    };
    props
      .paymentAuthComplete(dataToSend)
      .then(res => {
        window.sessionStorage.setItem('authResponse', JSON.stringify(res));
        props.paymentSignature({
          ticketId: authResponse.ticket.id,
          bytes: signUrl,
        });
        setTipAmount(
          Number(window.sessionStorage.getItem('tipAmt')).toFixed(2)
        );
        setPaymentAmount(
          Number(window.sessionStorage.getItem('payAmt')).toFixed(2)
        );
        window.sessionStorage.removeItem('tipAmt');
        window.sessionStorage.removeItem('payAmt');
        if (supportsSurvey) {
          getSurveyResponse();
        } else {
          setPaymentType(5);
        }
      })
      .catch(() => {
        props.paymentAuthError(dataToSend).then(() => {
          setPaymentType(8);
        });
      });
  };

  const printListener = data => {
    if (data.type === 'error') {
      props.setNotification({
        type: 'danger',
        message: data.message,
      });
    } else {
      props.closePrintNotification();
      setPaymentType(6);
    }
  };
  useEffect(() => {
    if (window.ReactNativeWebView) {
      try {
        EventEmitter.printData(
          res => {
            printListener(res);
          },
          err => {
            props.setNotification({
              type: 'danger',
              message: err,
            });
          }
        );
        EventEmitter.completePayment(
          res => {
            completePaymentListener(res);
          },
          err => {
            props.setNotification({
              type: 'danger',
              message: err,
            });
          }
        );
      } catch (e) {
        console.log('catch', e);
      }
    }
  }, []);

  const handleAuthComplete = () => {
    setIsTipsConfirm(false);
    window.sessionStorage.setItem('tipAmt', tipAmount);
    window.sessionStorage.setItem(
      'payAmt',
      getObjectValue(
        () =>
          Number(tipAmount) +
          Number(props.authResponse.checkHeader.taxAmount) +
          Number(props.authResponse.checkHeader.subTotalAmount),
        0
      )
    );
    const data = {
      type: 'completePayment',
      data: {
        transactionId: paymentAuthResponse.transactionId.toString(),
        merchantInvoiceId: props.authResponse.ticket.id.toString(),
        employeeId: props.authResponse.checkHeader.employeeId.toString(),
        latitude: '0',
        longitude: '0',
        notes: '',
        referenceId:
          props.authResponse.ticket.id.toString() ||
          props.authResponse.ticket.referenceId,
        amount: Math.floor(
          props.authResponse.ticket.totalAmount * 100
        ).toString(),
        tipAmount: Math.floor(tipAmount * 100).toString(),
      },
    };
    EventEmitter.sendMessage(
      data,
      res => {},
      err => {
        console.log(err);
      }
    );
  };

  const handleReceiptPopUpOpen = type => {
    setIsReceipt({ isOpen: true, type });
  };

  const handleReceipt = data => {
    const dataToSend = {
      ...data,
      storeId: props.deviceInfo.storeId,
      ticketId: props.authResponse.ticket.id
        ? props.authResponse.ticket.id
        : null,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      emailAddress: data.email || '',
      countryCode,
      phoneNumber: data.phone || '',
      optIn: data.optIn,
      employeeCard: null,
      accountNumber: data.accountNumber || null,
    };
    if (isReceipt.type === 'email') {
      props
        .receiptEmail(dataToSend)
        .then(() => {
          setPaymentType(6);
          setIsReceipt({ isOpen: false, type: '' });
        })
        .catch(err => {
          setIsReceipt({ isOpen: false, type: '' });
          props.setNotification({
            type: 'danger',
            message: err.message,
          });
        });
    } else {
      props
        .receiptSms(dataToSend)
        .then(() => {
          setPaymentType(6);
          setIsReceipt({ isOpen: false, type: '' });
        })
        .catch(err => {
          props.setNotification({
            type: 'danger',
            message: err.message,
          });
          setIsReceipt({ isOpen: false, type: '' });
        });
    }
  };

  const handleRetry = () => {
    setPaymentType(2);
  };

  const validateTips = url => {
    setSignUrl(url);
    if (!hideSignature && isEmpty(url)) {
      props.setNotification({
        type: 'danger',
        message: CUSTOM_MESSAGES().SIGNATURE_REQUIRED,
      });
    } else if ([''].includes(active)) {
      props.setNotification({
        type: 'danger',
        message: CUSTOM_MESSAGES().ENTER_TIP_MSG,
      });
    } else {
      setIsTipsConfirm(true);
    }
  };

  const handleGiftCardRoute = () => {
    props.setPaymentCheck({ ...props.paymentCheck }).then(() => {
      props.history.replace({
        pathname: `${APP_CONFIG.BASE_URL}/receipt/${
          tableData.id
        }?ticketSplitTypeId=${urlSearchParams(
          'ticketSplitTypeId'
        )}&splitValue=${urlSearchParams('splitValue')}&screenType=12&type=gift`,
      });
    });
  };

  const handleCheck = (type, url) => {
    switch (type) {
      case 'cash':
        handleCashPayment();
        break;
      case 'creditCard':
        handleCreditCard();
        break;
      case 'tips':
        validateTips(url);
        break;
      case 'giftCard':
        handleGiftCardRoute();
        break;
      case 'receipt':
        setPaymentType(6);
        break;
      default:
        break;
    }
  };

  const handlePayAnAmount = values => {
    const amount = Number(values.payAnAmount);
    const taxAmount = +(
      (amount * props.seat.taxAmount) /
      props.seat.subTotalAmount
    ).toFixed(2);
    const serviceChargeAmount =
      props.seat.serviceChargeAmount > 0
        ? +(
            (amount * props.seat.serviceChargeAmount) /
            props.seat.subTotalAmount
          ).toFixed(2)
        : 0;
    const discountAmount =
      props.seat.discountAmount > 0
        ? +(
            (amount * props.seat.discountAmount) /
            props.seat.subTotalAmount
          ).toFixed(2)
        : 0;
    const updatedData = {
      ...props.seat,
      subTotalAmount:
        amount - (taxAmount + serviceChargeAmount) + discountAmount,
      unpaidAmount: amount,
      taxAmount,
      paidAmount: 0,
      tipAmount: 0,
      totalAmount: amount,
      serviceChargeAmount,
      discountAmount,
    };
    props.setPaymentCheck(updatedData).then(() => {
      props.history.replace({
        pathname: `${APP_CONFIG.BASE_URL}/receipt/${updatedData.id}?ticketSplitTypeId=2&splitValue=1&screenType=2`,
      });
    });
  };

  const onPayFullCheckHandler = () => {
    setPaymentType(2);
    if (props.seat.paidAmount > 0) {
      handlePayAnAmount({ payAnAmount: props.seat.unpaidAmount });
    } else {
      const updatedData = {
        ...props.seat,
      };
      props.setPaymentCheck(updatedData).then(() => {
        if (props.seat.paidAmount === 0) {
          props.history.replace({
            pathname: `${APP_CONFIG.BASE_URL}/receipt/${updatedData.id}?ticketSplitTypeId=1&splitValue=1&screenType=2&type=cash`,
          });
        } else {
          props.history.replace({
            pathname: `${APP_CONFIG.BASE_URL}/receipt/${updatedData.id}?ticketSplitTypeId=1&splitValue=1&screenType=2&type=credit`,
          });
        }
      });
    }
  };

  const handleGiftCard = data => {
    const dataToSend = {
      accountNumber: data.cardNumber,
      securityCode: data.securityCode,
      deviceId: props.deviceInfo.deviceId,
      employeeId: Number(props.userInfo.id),
      storeId: props.deviceInfo.storeId,
      method: 'type',
    };
    props
      .giftCardBalance(dataToSend)
      .then(res => {
        setGiftBalance(res.balanceAmount);
      })
      .catch(err => {
        props.setNotification({
          type: 'danger',
          message: err.message,
        });
      });
  };

  const giftCardPayment = giftAmount => {
    const taxAmount = +(
      (giftAmount * tableData.taxAmount) /
      tableData.subTotalAmount
    ).toFixed(2);
    const serviceChargeAmount =
      tableData.serviceChargeAmount > 0
        ? +(
            (giftAmount * tableData.serviceChargeAmount) /
            tableData.subTotalAmount
          ).toFixed(2)
        : 0;
    const discountAmount =
      tableData.discountAmount > 0
        ? +(
            (giftAmount * tableData.discountAmount) /
            tableData.subTotalAmount
          ).toFixed(2)
        : 0;
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: tableData.id,
      employeeCard: null,
      authAmount: Number(giftAmount).toFixed(2),
      ticketSplitTypeId: Number(urlSearchParams('ticketSplitTypeId')),
      splitValue: Number(urlSearchParams('splitValue')),
      paymentStageId: getObjectValue(
        () => props.paymentCheck.paymentStageId,
        null
      ),
      subTotalAmount: tableData.subTotalAmount.toFixed(2),
      taxAmount,
      tipAmount,
      totalAmount: Number(tableData.totalAmount).toFixed(2),
      unpaidAmount: Number(tableData.unpaidAmount).toFixed(2),
      seatIds: SeatIds(),
      serviceChargeAmount,
      discountAmount,
      method: 'type',
      giftCardNumber: props.giftCard.accountNumber,
      securityCode: props.giftCard.securityCode,
    };
    props
      .giftCardPaymentInit(dataToSend)
      .then(res => {
        const dataToGiftCardPayment = {
          message: '',
          storeId: props.deviceInfo.storeId,
          deviceId: props.deviceInfo.deviceId,
          employeeId: props.userInfo.id,
          checkHeaderId: tableData.id,
          ticketId: res.ticket.id,
          subTotalAmount: tableData.subTotalAmount.toFixed(2),
          taxAmount,
          authAmount: Number(giftAmount).toFixed(2),
          tipAmount,
          transactionId: res.ticket.transactionId,
          clientTransactionId: res.ticket.clientTransactionId,
          authorizationCode: res.ticket.authorizationCode,
          paymentStageId: getObjectValue(
            () => props.paymentCheck.paymentStageId,
            null
          ),
          employeeCard: null,
          isPreAuth: false,
          partialAuth: false,
          serviceChargeAmount,
          discountAmount,
          method: 'type',
          giftCardNumber: props.giftCard.accountNumber,
          securityCode: props.giftCard.securityCode,
        };
        props
          .giftCardPayments(dataToGiftCardPayment)
          .then(response => {
            props.setAuthResponse(response).then(() => {
              setGiftBalance(0);
              setPaymentType(5);
            });
          })
          .catch(err => {
            props.setNotification({
              type: 'danger',
              message: err.message,
            });
          });
      })
      .catch(err => {
        props.setNotification({
          type: 'danger',
          message: err.message,
        });
      });
  };

  const handleSplitEvenly = (count, splitedValue) => {
    const subTotalAmount = props.seat.subTotalAmount / count;
    const taxAmount = props.seat.taxAmount / count;
    const serviceCharge =
      props.seat.serviceChargeAmount > 0
        ? props.seat.serviceChargeAmount / count
        : 0;
    const discountAmount =
      props.seat.discountAmount > 0 ? props.seat.discountAmount / count : 0;
    setSplitAmountValue({ count, splitedValue });
    if (
      props.seat.tickets.length > 0 &&
      [...props.seat.tickets].filter(d => d.paymentStatus === 'success')
        .length ===
        getObjectValue(() => props.seat.tickets[0].splitValue - 1, 0)
    ) {
      handlePayAnAmount({ payAnAmount: props.seat.unpaidAmount / count });
    } else {
      const updatedData = {
        ...props.seat,
        subTotalAmount,
        unpaidAmount:
          subTotalAmount + taxAmount + serviceCharge - discountAmount,
        taxAmount,
        paidAmount: 0,
        tipAmount: 0,
        totalAmount:
          subTotalAmount + taxAmount + serviceCharge - discountAmount,
        serviceChargeAmount: serviceCharge,
        discountAmount,
      };
      props.setPaymentCheck(updatedData).then(() => {
        props.history.replace({
          pathname: `${APP_CONFIG.BASE_URL}/receipt/${updatedData.id}?ticketSplitTypeId=3&splitValue=${count}&screenType=2`,
        });
      });
    }
  };

  const handleKeyboardValue = data => {
    setKeyboardValue(data);
  };

  let splitEvently = {
    name: LABEL().SPLIT_EVENLY,
    click: () => {
      props.history.replace({
        pathname: `${APP_CONFIG.BASE_URL}/receipt/${tableData.id}?ticketSplitTypeId=3&splitValue=1&screenType=9&type=split`,
      });
      setPaymentType(9);
    },
  };
  const payFullCheck = {
    name:
      props.seat.paidAmount === 0
        ? LABEL().PAY_FULL_CHECK
        : tableData.unpaidTips
        ? LABEL().PAY_REMAINING_BALANCE +
          ' ($' +
          (
            Number(tableData.unpaidAmount) + Number(tableData.unpaidTips)
          ).toFixed(2) +
          ')'
        : LABEL().PAY_REMAINING_BALANCE +
          ' ($' +
          Number(tableData.unpaidAmount).toFixed(2) +
          ')',
    click: () => onPayFullCheckHandler(),
  };
  let payByAmount = {
    name: LABEL().PAY_AN_AMOUNT,
    click: () => {
      props.history.replace({
        pathname: `${APP_CONFIG.BASE_URL}/receipt/${tableData.id}?ticketSplitTypeId=2&splitValue=1&screenType=10&type=payAnAmount`,
      });
      setPaymentType(10);
    },
  };
  payByAmount = null;
  const splitCheckNum =
    props.seat.paidAmount > 0 &&
    props.seat.tickets &&
    props.seat.tickets.length > 0
      ? props.seat.tickets[0].splitValue - 1
      : 0;
  const isSplitAllowed = getObjectValue(
    () =>
      props.seat.paidAmount > 0 &&
      Number(props.seat.tickets.length) < Number(splitCheckNum),
    false
  );
  if (isSplitAllowed) {
    splitEvently.name = `${LABEL().SPLIT_BY} 1/${
      props.seat.tickets[0].splitValue
    }`;
    splitEvently.click = () =>
      handleSplitEvenly(props.seat.tickets[0].splitValue);
  } else if (
    props.seat.paidAmount > 0 &&
    props.seat.tickets[0].splitValue > 1
  ) {
    splitEvently = null;
  } else if (props.seat.paidAmount > 0) {
    splitEvently = null;
  }
  const PaymentPageBtn = [payFullCheck, splitEvently, payByAmount];
  const validatePayAnAmount = value => {
    const error = {};
    if (
      Number(value.payAnAmount) === 0 ||
      Number.isNaN(value.payAnAmount) ||
      value.payAnAmount === '.'
    ) {
      error.payAnAmount = 'Enter a amount more than 0 to pay';
    } else if (Number(value.payAnAmount) > Number(tableData.unpaidAmount)) {
      error.payAnAmount = 'Enter amount less than total due amount';
    }
    return error;
  };

  const handleSurveySubmit = () => {
    setPaymentType(5);
  };

  const handleCountryCodeChange = event => {
    setCountryCode(event.id);
  };

  return (
    <div
      className={cn('col-12 col-md-12 p-0 row mx-0 h-100 overflowY rowReverse')}
    >
      {props.loading && <Loader />}
      {handleBackButton().isShow && (
        <div
          className="position-fixed text-primary od-text-primary"
          style={{ left: '5px', top: 0, zIndex: '999' }}
        >
          <i
            role="presentation"
            className="fa fa-chevron-left fs-26"
            aria-hidden="true"
            onClick={() => handleBackButton().url()}
          />
        </div>
      )}
      <div
        className="position-fixed text-primary od-text-primary"
        style={{ right: '5px', top: 0, zIndex: '999' }}
      >
        <i
          role="presentation"
          className="fa fa-times fs-26"
          aria-hidden="true"
          onClick={() =>
            props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`)
          }
        />
      </div>
      <div className="col-12 col-md-7 px-2 py-4 h-100">
        <div className="row h-100 mx-0 border border-color-secondary rounded">
          <ReceiptScreen
            tableData={{ ...tableData }}
            currenySymbol={currenySymbol}
            renderModifier={renderModifier}
            paymentType={paymentType}
            tipAmount={tipAmount}
            paymentAmount={paymentAmount}
            active={active}
            handleButtonClick={handleButtonClick}
            keyboardValue={keyboardValue}
            handleKeyboardValue={handleKeyboardValue}
            paymentFlowType={props.paymentFlowType}
          />
        </div>
      </div>
      <div className="col-12 col-md-5 px-2 py-4 h-100">
        <div className="row mx-0 h-100 border-color-secondary border rounded od-container-card-background background-secondary">
          <PaymentScreen
            isCash={
              urlSearchParams('ticketSplitTypeId') === '1' &&
              urlSearchParams('type') !== 'stage' &&
              urlSearchParams('giftApplied') !== 'true'
            }
            tipAmount={tipAmount}
            paymentAmount={paymentAmount}
            totalAmount={tableData.totalAmount}
            paymentType={paymentType}
            loading={props.loading}
            loaded={props.loaded}
            error={props.error}
            currenySymbol={currenySymbol}
            handleButtonClick={handleButtonClick}
            setPaymentType={setPaymentType}
            handleRoute={handleRoute}
            tipsList={tipsList}
            handlePrint={handlePrint}
            active={active}
            handleCheck={handleCheck}
            logo={props.auth.logoImageUrl}
            paymentCallBack={handleCreditCardAuth}
            handleReceiptPopUpOpen={handleReceiptPopUpOpen}
            handleRetry={handleRetry}
            PaymentPageBtn={PaymentPageBtn}
            isGiftCard={props.auth.loyaltyInfo.supportsGiftCardPayment}
            isSecurityCode={props.auth.loyaltyInfo.validateGiftCardSecurityCode}
            setConfModelOpen={setConfModelOpen}
            handleSplitEvenly={handleSplitEvenly}
            handlePayAnAmount={handlePayAnAmount}
            keyboardValue={keyboardValue}
            handleKeyboardValue={handleKeyboardValue}
            validatePayAnAmount={validatePayAnAmount}
            hideSignature={hideSignature}
            subTotalAmount={tableData.subTotalAmount}
            handleSurveySubmit={handleSurveySubmit}
            handleGiftCard={handleGiftCard}
            giftCardPayment={giftCardPayment}
            giftBalance={giftBalance}
            paymentFlowType={props.paymentFlowType}
          />
        </div>
      </div>
      <ReceiptScreenPopUp
        onClose={() => setIsReceipt({ isOpen: false, type: '' })}
        isOpen={isReceipt.isOpen}
        type={isReceipt.type}
        handleReceipt={handleReceipt}
        countryCode={countryCode}
        phoneNumberMaxLength={phoneNumberMaxLength}
        handleCountryCodeChange={handleCountryCodeChange}
      />
      {isTipsConfirm && (
        <TipsConfirmPopUp
          isOpen={isTipsConfirm}
          supportsWarnOnUnusualTip={supportsWarnOnUnusualTip}
          onClose={() => setIsTipsConfirm(false)}
          onSubmitTips={() => handleAuthComplete()}
          tipAmount={tipAmount}
        />
      )}
      <Modal isOpen={props.isPrintOpen} isModalCenter>
        <div className="col-12 my-2 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
          {/* <div className="p-1 position-absolute" style={{ right: '5px', top: '0px' }}>
              <div className="" role="presentation" onClick={() => { props.closeModal(); }}>
                <i className="fa fa-times" aria-hidden="true" />
              </div>
            </div> */}
          <div>
            <div className="text-left">
              Printer IP Address :{props.printData.printerIpAddress}
            </div>
            <br />
            <div className="text-left">
              Printer Name: {props.printData.printerName}
            </div>
            <br />
            <div className="text-left">
              Printer Port: {props.printData.printerPort}{' '}
            </div>
          </div>
          <div className={cn(style.imgSpin, 'od-spinner position-absolute')} />
        </div>
      </Modal>
      <Modal isOpen={confModelOpen} isModalCenter>
        <div className="col-12 my-2 justify-content-center align-items-center position-relative text-center od-text-primary text-primary">
          <div
            className="p-1 position-absolute"
            style={{ right: '5px', top: '0px' }}
          >
            <div
              className="fs-24"
              role="presentation"
              onClick={() => {
                setConfModelOpen(false);
              }}
            >
              <i className="fa fa-times" aria-hidden="true" />
            </div>
          </div>
          <div className="col-12 fs-18 mt-10 fw-700 text-center">
            <div className="fs-20">
              {CUSTOM_MESSAGES().PROCEED_WITH_CASH_PAYMENT_OF} {currenySymbol}
              {tableData && tableData.totalAmount.toFixed(2)}?
            </div>
          </div>
          <div className="col-12 d-flex justify-content-center">
            <button
              type="submit"
              className="col-4 m-2 btn btn-secondary od-btn-secondary"
              onClick={() => setConfModelOpen(false)}
            >
              <div className="fs-18">{LABEL().NO}</div>
            </button>
            <button
              type="submit"
              className="col-4 m-2 btn btn-primary btn-ripple btn-lg od-btn-primary"
              onClick={() => {
                handleCheck('cash');
                setConfModelOpen(false);
              }}
            >
              <div className="fs-18">{LABEL().YES}</div>
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = state => ({
  loading:
    state.payment.loading || state.storeChecks.loading || state.survey.loading,
  deviceInfo: state.oauth.deviceInformation,
  userInfo: state.oauth.loggedInUserData,
  auth: state.oauth.authInfo,
  seat: state.orders.seats,
  paymentCheck: state.orders.paymentCheck,
  authResponse: state.payment.authResponse,
  isPrintOpen: state.notification.isPrintOpen,
  printData: state.notification.printData,
  surveyData: state.survey.surveyData,
  giftCard: state.payment.giftCard,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      paymentInitialization,
      giftCardBalance,
      paymentCash,
      paymentAuth,
      paymentAuthError,
      setNotification,
      paymentAuthComplete,
      receiptSms,
      paymentSignature,
      setAuthResponse,
      receiptEmail,
      updateChecksAfterResponse,
      removeSeat,
      removePaymentCheck,
      receiptPrint,
      updateSeatInfo,
      setPaymentCheck,
      setPrintNotification,
      closePrintNotification,
      submitSurvey,
      getSurvey,
      giftCardPaymentInit,
      giftCardPayments,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ProcessAuthFlow);
